import request from '@utils/request'
import configRequest from "@src/config/request";

export const state = {};

export const mutations = {};

export const getters = {};

export const actions = {
  /**
   * 取得會員優惠券列表
   * @param commit
   * @param paramAlias
   * @param basePrice
   * @param orderUuid
   * @param limit
   * @param search
   * @param page
   * @returns {*}
   */
  fetchMemberCouponList({ commit }, {
    paramAlias,
    basePrice,
    orderUuid,
    limit = 9,
    page = 1
  } = {}) {
    return request
      .post(`/merchant/member/coupon/search`, {
        paramAlias,
        basePrice,
        orderUuid,
        limit,
        page
      }, {
        ...configRequest,
        name: 'fetchMemberCouponList'
      })
  },

  /**
   * 檢查會員優惠券
   * @param commit
   * @param code
   * @param paramAlias
   * @param basePrice
   * @param orderUuid
   * @returns {*}
   */
  checkMemberCoupon({ commit }, {
    code,
    paramAlias,
    basePrice,
    orderUuid,
  }) {
    return request
      .post('/merchant/member/coupon/check', {
        code,
        paramAlias,
        basePrice,
        orderUuid,
      }, {
        ...configRequest,
        name: 'checkMemberCoupon'
      })
  },
};
